<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentToDo /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/worker/dashboard/HeaderDash.vue'
import SideMenu from '@/components/worker/dashboard/SideMenu.vue'
import ContentToDo from '@/components/worker/dashboard/modules/to-do/ContentToDo.vue'

export default 
{
  name: 'ToDo',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentToDo
  }
}
</script>
<style>

</style>